export const webApplicationsContactUrl =
  "/contact-us/?service=software-development&source=web-applications-cms"

export const webApplicationsSections = [
  {
    title: "Joomla website development and support.",
    paragraphText:
      "Already running Joomla? We can help improve the website you have, resolve problems, develop new functionality and make it easier for your team to manage content. We can also plan a new Joomla website around your audience and business requirements.\n\n" +
      "Support starts with a review of the installed version, templates, extensions, hosting and any custom code. That gives us a practical basis for agreeing repairs, updates, performance improvements or a larger redevelopment.\n\n" +
      "If you are considering a move to another platform, we assess the content, functionality and integrations before recommending a route forward.",
    imgFilename: "web-design-new.jpg",
    ctaText: "Discuss your Joomla website",
    ctaUrl: webApplicationsContactUrl,
  },
  {
    title: "Umbraco website development and support.",
    paragraphText:
      "We can work with your existing Umbraco website or help plan a new build. Projects can include content structure, responsive templates, custom functionality, integrations and improvements to the experience for visitors and editors.\n\n" +
      "Before taking on an existing site, we review its version, codebase, packages, hosting and deployment process. Upgrade and migration work is then scoped around what that particular setup needs.\n\n" +
      "The aim is a website that supports your organisation and remains practical for the people responsible for publishing and maintaining it.",
    imgFilename: "jamstack-maintenance.jpg",
    ctaText: "Discuss your Umbraco website",
    ctaUrl: webApplicationsContactUrl,
  },
  {
    title: "Bespoke web applications for everyday business needs.",
    paragraphText:
      "When your team needs to complete a task online, a bespoke application can provide a clearer way to work. That could mean a customer portal, a booking tool, an internal dashboard or an application for managing requests, documents and approvals.\n\n" +
      "We start with the users, the information they need and the actions they must complete. Access permissions, data handling, integrations and ongoing maintenance are considered alongside the interface.\n\n" +
      "A focused first release lets you solve the most useful part of the problem, review how people use it and plan further development around real needs.",
    imgFilename: "software-development.jpg",
    ctaText: "Plan a web application",
    ctaUrl: `${webApplicationsContactUrl}&objective=build-web-application`,
  },
  {
    title: "Connect your website to the systems behind it.",
    paragraphText:
      "A website or application often needs to share information with CRM, booking, payment, email or operational systems. We can develop suitable API integrations and workflows to reduce duplicate entry and help information reach the people who need it.\n\n" +
      "We assess the available interfaces, data ownership, permissions and failure handling before agreeing the integration. Testing covers the full journey, including what happens when an external system is unavailable.\n\n" +
      "For a wider operational process, our business process automation service provides a connected route from the website through to the work your team does behind the scenes.",
    imgFilename: "business-process-automation.jpg",
    ctaText: "Explore business process automation",
    ctaUrl: "/services/business-process-automation/",
  },
]

export const webApplicationsProcess = [
  {
    title: "Understand",
    text: "We review your goals, users, current platform, content, integrations and constraints, including budget and the people maintaining the system.",
  },
  {
    title: "Agree the approach",
    text: "We recommend a platform and scope, explain the trade-offs and agree the required outcome, delivery stages and ongoing costs.",
  },
  {
    title: "Build and test",
    text: "Design and development progress through useful review points, with checks for core journeys, permissions, integrations and responsive behaviour.",
  },
  {
    title: "Launch and support",
    text: "We plan the release, provide a practical handover and agree how hosting, maintenance and future improvements will be managed.",
  },
]

export const webApplicationsFaqs = [
  {
    question: "Do you work with platforms other than WordPress?",
    answer:
      "Yes. WordPress is our specialism, and we also offer Joomla and Umbraco website development and support, bespoke web applications and API integrations. We review the requirements and existing setup before confirming the approach and scope.",
  },
  {
    question: "Can you take over an existing Joomla or Umbraco website?",
    answer:
      "We can review an existing website for ongoing support, repairs or development. The initial assessment covers the platform version, templates or packages, custom code, hosting and available documentation. We then agree what can be supported and any changes needed before work begins.",
  },
  {
    question:
      "Can you build a customer portal or an internal business application?",
    answer:
      "Yes. We can scope bespoke applications such as customer portals, booking tools, dashboards and request or approval workflows. We begin with the people using the application, the tasks they need to complete and the data and systems involved.",
  },
  {
    question: "How do you decide which platform to recommend?",
    answer:
      "We consider content management, functionality, integrations, user permissions, budget, hosting and long-term maintenance. WordPress remains a strong option for many of our projects. When another CMS or a bespoke application better fits the requirements, we explain the reasons and trade-offs.",
  },
  {
    question: "Can you migrate our website to a different CMS?",
    answer:
      "We can assess a migration between suitable platforms. Planning includes content and media, URLs and redirects, custom functionality, integrations, editor training and the launch process. The scope depends on the source website and the requirements of the destination platform.",
  },
  {
    question: "What happens after the website or application launches?",
    answer:
      "We can agree ongoing support, maintenance and planned improvements around the platform and its importance to your business. Hosting responsibilities, update arrangements, documentation and handover are defined as part of the project.",
  },
  {
    question: "How much does web application or CMS development cost?",
    answer:
      "Projects are scoped and priced individually. We assess the required functionality, existing code, integrations and delivery stages, then provide a proposal identifying the project scope and relevant hosting, licensing or other third-party costs. Timescales are confirmed before work begins.",
  },
]
